import React, { Component } from "react";
import { observer } from "mobx-react";
import { Container, Grid } from "semantic-ui-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import RouteWrapper from "../../spa/component/wrapper/RouteWrapper";
import CustomerPortalStore from "../stores/CustomerPortalStore";
import "../styles/CustomerTourPage.less";
import CustomerOrCoCustomerCards from "../components/CustomerOrCoCustomerCards";
import BannerDesign from "../components/BannerDesign";
import CustomerToursList from "../components/CustomerToursList";
import CustomerPortalMenu from "../components/CustomerPortalMenu";

@observer
class CustomerPortalToursPage extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    document.title = t("customerPortal:customerPortal");
  }

  componentDidMount() {
    const { showError, match, customerPortalStore } = this.props;
    const { customerStore, tourStore } = customerPortalStore;

    tourStore.tourId = parseInt(match.params.tourId, 10);
    customerStore.customerId = parseInt(match.params.customerId, 10);
    customerStore
      .load()
      .then(() => {
        const { customer } = customerStore;
        const canonicalLink = document.createElement("link");
        canonicalLink.rel = "canonical";
        canonicalLink.href = `http://${customer.canonicalDomain}/customer-portal/${customer.customerId}/tours${
          tourStore.tourId ? `/${tourStore.tourId}` : ""
        }`;
        document.head.appendChild(canonicalLink);
        const rssLink = document.createElement("link");
        rssLink.rel = "alternate";
        rssLink.title = "RSS 2.0";
        rssLink.type = "application/rss+xml";
        rssLink.href = `http://${customer.canonicalDomain}/customer-portal/${customer.customerId}/tours${
          tourStore.tourId ? `/${tourStore.tourId}` : ""
        }?format=rss`;
        document.head.appendChild(rssLink);
      })
      .catch(error => showError(error.message));

    customerPortalStore.loadTourIndex().catch(error => showError(error.message));
  }

  changeActiveItem(name) {
    const { match, redirectTo } = this.props;
    redirectTo(`/${match.params.customerId}/${name}`);
  }

  render() {
    const { showError, customerPortalStore, pages, t } = this.props;
    const { isLoading, customerStore, tourStore, bannerFromTours, coCustomer } = customerPortalStore;
    if (isLoading) {
      return <LoadingWrapper loading />;
    }

    const { customer } = customerStore;
    const { tours } = tourStore;

    document.title = t("customerPortal:allToursForCustomer", {
      customerFirstName: customer.firstName,
      customerLastName: customer.lastName,
    });

    return (
      <>
        <div
          id="masthead"
          className="ui inverted vertical masthead center aligned segment"
          style={{
            backgroundImage: `url(${pages[0].photoUrl ? pages[0].photoPathWeb : bannerFromTours})`,
            backgroundPosition: "center",
            boxShadow: "inset 0 0 0 1000px rgba(0,0,0,.4)",
            height: "400px",
          }}
        >
          <CustomerPortalMenu
            activeItem="tours"
            changeActiveItemCallback={name => this.changeActiveItem(name)}
            pages={pages}
          />
          <BannerDesign activeItem="tours" pages={pages} />
        </div>

        <Container className="customerTourPage">
          <Grid doubling columns={2} style={{ marginTop: -100 }}>
            <Grid.Column>
              <CustomerOrCoCustomerCards customerOrCoCustomer={customer} customerLogoOnly />
            </Grid.Column>
            <Grid.Column>
              {coCustomer ? <CustomerOrCoCustomerCards customerOrCoCustomer={coCustomer} customerLogoOnly /> : null}
            </Grid.Column>
          </Grid>
          <br />
          <CustomerToursList
            tours={tours}
            infiniteLoadMore={tourStore.infiniteLoadMore}
            loadMoreCallback={() => customerPortalStore.loadTourIndex(true).catch(error => showError(error.message))}
          />
          <div className="ui basic segment" />
        </Container>
      </>
    );
  }
}

CustomerPortalToursPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      customerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      tourId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
  }),
  pages: PropTypes.array.isRequired,
  customerPortalStore: PropTypes.instanceOf(CustomerPortalStore),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ErrorWrapper(RouteWrapper(CustomerPortalToursPage)));
